import {Col, Row} from "react-bootstrap";
import React from "react";
import {trans} from "../../../../../../translations/translations";

const HungerAdvice1 = () => {
    return (
        <Row className={"response-row"}>
            <Col xs={12} className={"title mb-2"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer1.hunger.advice1.title.text1', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer1.hunger.advice1.title.text2', 'sos')}</span>
                    <span className={"me-1"}>{trans('results.answer1.hunger.advice1.title.text3', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer1.hunger.advice1.title.text4', 'sos')}</span>
                    <span className={"me-1 "}>{trans('results.answer1.hunger.advice1.title.text5', 'sos')}</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice1.sub.text1', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result"}>
                    <ul>
                        <li>{trans('results.answer1.hunger.advice1.sub.breakfast.title', 'sos')}</li>
                        <p>{trans('results.answer1.hunger.advice1.sub.breakfast.sub', 'sos')}</p>
                        <li>{trans('results.answer1.hunger.advice1.sub.lunch.title', 'sos')}</li>
                        <p>{trans('results.answer1.hunger.advice1.sub.lunch.sub', 'sos')}</p>
                        <li>{trans('results.answer1.hunger.advice1.sub.collation.title', 'sos')}</li>
                        <p>{trans('results.answer1.hunger.advice1.sub.collation.sub', 'sos')}</p>
                        <li>{trans('results.answer1.hunger.advice1.sub.diner.title', 'sos')}</li>
                        <p>{trans('results.answer1.hunger.advice1.sub.dinner.sub', 'sos')}</p>
                    </ul>
            </Col>
        </Row>
    )
}

export default HungerAdvice1;
